// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import UserDataManage from "../../../model/UserDataManage";
import MilitaryMyOfficerItem from "./MilitaryMyOfficerItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryMyOfficerLayer extends BasePopUpLayer {

    @property(cc.Prefab)
    itemPrefab: cc.Prefab = null;
    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        
        this.initLayer();
    }

    initLayer() {
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;
        let officeList = militaryOfficerData.lists;
        this.scrollView.content.removeAllChildren();
        officeList.forEach((v)=> {

            if (v.bDrop) {
                return;
            }

            // if (utilsModel.isValidNumberValue(v.curGarrisonCity)) {
            //     return;
            // }

            let nodeItem = cc.instantiate(this.itemPrefab);
            let scirpt = nodeItem.getComponent(MilitaryMyOfficerItem);
            scirpt.setData(v.id);
            this.scrollView.content.addChild(nodeItem);
        });
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
